/**
 * /dashboard/accounting/money/receipts/new — Create receipt (G_ACC6c).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/receipts/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ReceiptForm } from "@/components/accounting/receipt-form";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/money/receipts/new",
)({
  component: NewReceiptRoute,
});

function NewReceiptRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New receipt"
      description="Record a customer payment and apply it to open invoices."
    >
      <ReceiptForm />
    </AccountingModuleShell>
  );
}
